module.exports = __webpack_public_path__ + "img/check-comp.b847f448.svg";